import Layout from '@modules/layout/components/layout';
import Permissions from '@security/permissions';

export default [
  {
    path: '',
    component: Layout,
    children: [
      {
        name: 'stripeIncome',
        path: '/income/:tabName?',
        component: () => import('@modules/stripe/stripe-income/components/stripe-income-page.vue'),
        meta: {
          auth: true,
          permission: Permissions.values.subpropertyEdit,
        },
        props: true,
      },
    ],
  },
];
